export const maxClientsAmount = 100000000;
export const maxVoiceAmount = 100;
export const minVoiceAmount = 0;
export const defaultVoiceAmount = 60;
export const minClientsAmount = 1000;
export const defaultClientsAmount = 10000;
export const colorDigital = '#a6c8ff';
export const colorVoice = '#4589ff';

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30WAROI = '30A47';
